// extracted by mini-css-extract-plugin
module.exports = {"custom-link":"_3E6kjGcTd3X9qeI7X_Kzdr"};